import { render, staticRenderFns } from "./WineDetail.vue?vue&type=template&id=b5f56954&scoped=true"
import script from "./WineDetail.vue?vue&type=script&lang=js"
export * from "./WineDetail.vue?vue&type=script&lang=js"
import style0 from "./WineDetail.vue?vue&type=style&index=0&id=b5f56954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f56954",
  null
  
)

export default component.exports